<citadel-form-section>
  <div class="header-strip mx-32 mt-32 mb-32">
    <div class="formHeader"> Select how you would like to receive your OTP:</div>
  </div>
  <citadel-radio-group name="otpTypeLabels" [items]="otpTypeLabels" [(ngModel)]="otpType"
  (change)="onOtpChannelChange($event)" (keyup)="handleKeyUp($event)" class="mx-32" />

  @if (showChannelRequiredMsg) {
    <div class="invalid-feedback mx-32">
      <small>Please select an option before you continue</small>
    </div>
  }
  <div class="mx-32 mt-32 mb-32">
    <citadel-button [isSubmit]="true" buttonStyle="primary" (click)="sendOtp()" [heading]="'Send OTP'"
    [icon]="{right:'chevron-right'}" buttonSize="large" />
  </div>
</citadel-form-section>
